import MarketplaceDetail from './marketplacedetails';

export default MarketplaceDetail;